/* eslint-disable no-use-before-define */
import React from 'react';
import { Controller } from 'react-hook-form';
import ComboBoxInput from '../Inputs/ComboBoxInput';

const ControlledComboboxInput = props => {
  const { id, options, name, control, TextInputProps = {}, ...rest } = props;

  return (
    <Controller
      name={name}
      control={control}
      render={({ onChange }) => {
        return (
          <ComboBoxInput
            id={id}
            options={options}
            TextInputProps={TextInputProps}
            onChange={(_, selectedOption) => {
              onChange(selectedOption);
            }}
            {...rest}
          />
        );
      }}
    />
  );
};

export default ControlledComboboxInput;
